export default "/static/media/default-properties.092a7225.css";